import { render, staticRenderFns } from "./setting-winning.vue?vue&type=template&id=250164c4&scoped=true"
import script from "./setting-winning.vue?vue&type=script&lang=js"
export * from "./setting-winning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250164c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('250164c4')) {
      api.createRecord('250164c4', component.options)
    } else {
      api.reload('250164c4', component.options)
    }
    module.hot.accept("./setting-winning.vue?vue&type=template&id=250164c4&scoped=true", function () {
      api.rerender('250164c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/components/setting-page/components/form-b/setting-winning.vue"
export default component.exports